import { useMutation } from 'react-query';

import { createComment } from '../infrastructure/create-comments';
import { useInvalidateAllComments } from './utils/invalidate-all-comments';

export const useAddCommentMutation = () => {
    const invalidateAll = useInvalidateAllComments();

    return useMutation({
        mutationFn: createComment,
        onSuccess: () => {
            invalidateAll();
        },
    });
};
